import debug from 'bows';
import AuthorGrid from '../_author-grid';

const log = debug('subscribe');

class Authors {
	constructor(opts) {
		this.opts = opts;

		let authorGridNode = document.querySelector( '.author-grid' );
		if ( authorGridNode ) {
			this.authorGrid = new AuthorGrid( authorGridNode );
		}

		log(this);
	}
}

export default function( opts = {} ) {
	return new Authors(opts);
}
